import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class VehiclesService {
  constructor(private http: HttpClient) {}

  getAllVehicle(data) {
    return this.http.post(environment.apiUrl + "trucks/all", data);
  }
  addVehicle(data) {
    return this.http.post(environment.apiUrl + "truck/add", data);
  }
  updateVehicle(id, data) {
    return this.http.put(environment.apiUrl + `truck/update/${id}`, data);
  }
  deleteVehicle(id) {
    return this.http.delete(environment.apiUrl + `truck/delete/${id}`);
  }

  addImage(file) {
    const formData = new FormData();
    formData.append("files", file);
    return this.http.post(environment.filePath, formData);
  }

  addTyres(data) {
    return this.http.post(environment.apiUrl + "truck-tyre/add", data);
  }
  getTyres(data) {
    return this.http.post(environment.apiUrl + "truck-tyres/all", data);
  }
  ediTyres(id, data) {
    return this.http.put(environment.apiUrl + `truck-tyre/update/${id}`, data);
  }
  delete(id) {
    return this.http.delete(environment.apiUrl + `truck-tyre/delete/${id}`);
  }


  // ton apis
  getTruckTons(data) {
    return this.http.post(environment.apiUrl + "truck-tons/all", data);
  }
  addTons(data) {
    return this.http.post(environment.apiUrl + "truck-ton/add", data);
  }
  updateTons(id, data) {
    return this.http.put(environment.apiUrl + `truck-ton/update/${id}`, data);
  }
  deleteTons(id) {
    return this.http.delete(environment.apiUrl + `truck-ton/delete/${id}`);
  }
}
